export default interface PagerOptions {
    page: number;
    pageSize: number;
    pageCount: number;
    rowCount: number;
    rowStart: number;
    rowEnd: number;
}

export function InitPagerOptions(recordCount: number, pageCount: number, page: number, pageSize: number): PagerOptions {
    const pagerOptions: PagerOptions = {
        page: page,
        pageSize: pageSize,
        pageCount: pageCount,
        rowCount: recordCount,
        rowStart: 0,
        rowEnd: 0
    };

    if (recordCount > 0) {
        pagerOptions.rowStart = (pagerOptions.page - 1) * pagerOptions.pageSize + 1;
        pagerOptions.rowEnd = pagerOptions.rowStart + pagerOptions.pageSize - 1;
    }
    else {
        pagerOptions.rowStart = pagerOptions.rowEnd = 0;
    }

    if (pagerOptions.rowEnd > pagerOptions.rowCount) {
        pagerOptions.rowEnd = pagerOptions.rowCount;
    }

    return pagerOptions;
}